import { ActivityService, ActivityStatus, ActivityStatusName, handleServerValidation } from 'ac-ui-core-local';
import { Component, HostListener, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, NgForm } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { SafeHtml } from '@angular/platform-browser/src/security/dom_sanitization_service';

export interface ActivityStatusDialogModel {
	eventId: number;
	activityId: number;
	status: ActivityStatus;
	canRequestBooking: boolean;
}

@Component({
	templateUrl: './activity-status-dialog.component.html',
	styleUrls: ['./activity-status-dialog.component.scss']
})
export class ActivityStatusDialogComponent implements OnInit {
	@ViewChild('ngForm') private ngForm: NgForm;
	public isSubmitting: boolean;
	public form: FormGroup;
	public previewContent: SafeHtml;
	public enablePreview: boolean;
	public noteLabel: string;
	public title: string;

	constructor(private _fb: FormBuilder, private _as: ActivityService, private dialogRef: MatDialogRef<boolean>,
		private _s: DomSanitizer, @Inject(MAT_DIALOG_DATA) private data: ActivityStatusDialogModel) {
	}

	ngOnInit() {
		this.form = this._fb.group({ notes: null });

		if (this.data.status === ActivityStatus.NeedsBooking && this.data.canRequestBooking) {
			this.title = 'Request Booking';
			this.noteLabel = 'Email Notes';
			this.enablePreview = true;
		} else {
			this.title = `Update Activity Status: ${ActivityStatusName(this.data.status)}`;
			this.noteLabel = 'Notes';
		}
	}

	@HostListener('window:keydown', ['$event'])
	keyEvent(event: KeyboardEvent) {
		if (!event.shiftKey && event.keyCode === 13) {
			event.preventDefault();
			this.ngForm.ngSubmit.emit();
		}
	}

	async preview() {
		const content = await this._as.previewBookingRequest(this.data.eventId, this.data.activityId, this.form.value.notes || '');

		this.previewContent = this._s.bypassSecurityTrustHtml(content);
	}

	async onSubmit(form: any, isValid: boolean) {
		if (!isValid) return;

		this.isSubmitting = true;

		try {
			await this._as.updateActivityStatus(this.data.eventId, this.data.activityId, this.data.status, form.notes);

			this.dialogRef.close({ notes: form.notes });
		} catch (error) {
			this.isSubmitting = false;
			// todo: handle error
			alert(handleServerValidation(error));
			console.log(error);
		}
	}
}
